export default __webpack_public_path__ + "static/media/aboutSecImg.aaba5451.svg";